import moment from "moment";
import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import GetUpdatedOnBy from "../GetUpdatedOnBy";

const Deleted = ({ name, id, updatedBy, updatedAt }) => {
  return (
    <div className={styles.tabContainer}>
      <div className={styles.badgeContainer}>
        <div className={styles.campaignName}>{name}</div>
        <div className={classNames(styles.badge, styles.badgeError)}>
          <div>Deleted</div>
        </div>
      </div>
      <GetUpdatedOnBy updatedBy={updatedBy} updatedAt={updatedAt} />
      <InfoBlock
        header="Deletion Details"
        className={styles.changeTracking}
        config={[
          {
            title: "Deleted On",
            size: {
              sm: 6,
              xs: 6,
            },
            value: updatedAt ? moment(updatedAt).format("MMM DD, YYYY, h:mm A") : undefined,
          },
          {
            title: "Name & ID",
            size: {
              sm: 6,
              xs: 6,
            },
            value: `${name} (${id})`,
          },
        ]}
      />
    </div>
  );
};

export default Deleted;
